export const POST_BEACH_SAP_DATA = "POST_BEACH_SAP_DATA";
export const POST_BEACH_SAP_DATA_SUCCESS = "POST_BEACH_SAP_DATA_SUCCESS";

export default {
  POST_BEACH_SAP_DATA,
  POST_BEACH_SAP_DATA_SUCCESS,
};
